module.exports = __webpack_public_path__ + "img/to.53f7a35d.svg";